import React, { useState } from 'react';
import { Instagram, Facebook, Copy, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import toast from 'react-hot-toast';

const EmailDisplay = () => {
  const [user, domain] = ['hola', 'iznoval.com'];
  const [isCopied, setIsCopied] = useState(false);
  const email = `${user}@${domain}`;

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setIsCopied(true);
      toast.success('Email copiado al portapapeles');
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      toast.error('Error al copiar el email');
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
      <span className="font-semibold mb-1 sm:mb-0">Email:</span>
      <div className="flex items-center space-x-2">
        <a 
          href={`mailto:${email}`}
          className="text-gray-300 hover:text-white transition-colors break-all"
        >
          {user}[punto]{domain}
        </a>
        <button
          onClick={copyEmail}
          className="p-1 text-gray-300 hover:text-white transition-colors rounded-full"
          title="Copiar email"
        >
          {isCopied ? (
            <Check className="h-4 w-4" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  );
};

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo y Redes Sociales */}
          <div className="text-center md:text-left space-y-4">
            <div className="flex justify-center md:justify-start items-center">
              <Logo size="lg" />
            </div>
            <p className="text-gray-300 max-w-md mx-auto md:mx-0">
              Difundiendo alegría y creatividad a través del arte de la decoración navideña.
              ¡Únete a nuestra comunidad y comparte tu espíritu festivo!
            </p>
            <div className="flex justify-center md:justify-start space-x-6">
              <a 
                href="https://www.instagram.com/ofertium_es" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-secondary transition-colors p-2"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a 
                href="https://www.facebook.com/ofertium.es" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-secondary transition-colors p-2"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a 
                href="https://www.tiktok.com/@ofertium_es" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-secondary transition-colors p-2"
              >
                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Contacto */}
          <div className="text-center md:text-left space-y-4">
            <h3 className="font-bold text-lg mb-2">Contacto</h3>
            <div className="space-y-4 text-gray-300">
              <EmailDisplay />
            </div>
          </div>

          {/* Legal */}
          <div className="text-center md:text-left space-y-4">
            <h3 className="font-bold text-lg mb-2">Legal</h3>
            <ul className="space-y-3 text-gray-300">
              <li>
                <Link to="/bases-legales" className="hover:text-white transition-colors block py-1">
                  Bases Legales
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="hover:text-white transition-colors block py-1">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-white transition-colors block py-1">
                  Política de Cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-gray-400">
          <p className="mb-2">© {new Date().getFullYear()} Concurso de Árboles de Navidad. Todos los derechos reservados.</p>
          <p className="flex items-center justify-center">
            Hecho con <span className="text-red-500 mx-1">♥</span> por{' '}
            <a 
              href="https://iznoval.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ml-1 hover:text-secondary transition-colors"
            >
              Iznoval.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}